<script setup>
import {
  KkIcon,
} from '../../../../components/base'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  isEditable: {
    type: Boolean,
    required: true
  },
})
const emit = defineEmits(['click'])

const onClick = ($event) => {
  emit('click', $event)
}

</script>

<template>
  <button
    :class="{ 'noPointer': !props.isEditable }"
    type="button"
    class="category"
    :disabled="!props.isEditable"
    @click="onClick($event)"
  >
    <span>
      {{ props.name ? props.name : t('pages.CompaniesStoreSnsPost.index.noCategory') }}
    </span>
    <KkIcon
      v-if="props.isEditable"
      name="edit"
      color="rgba(58, 59, 63, 0.7)"
      class="category__icon"
    />
  </button>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.noPointer {
  cursor: default
}

.category {
  display: flex;
  color: $color-font-base;
  font-weight: bold;
  font-size: 10px;
  border-radius: 12px;
  background-color: #ECEDF0;
  padding: 0 8px;
  margin-bottom: 8px;

  &__icon {
    width: 12px;
    margin: auto 0 auto 4px;
  }
}
</style>
